import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    languagenewLabelList :[]
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_LANGUAGE_NEW_LABEL_LIST:
            return updateObject(state, { languagenewLabelList: action.state })
        default:
            return state;
    }
}

export default reducer
